module.exports = __webpack_public_path__ + "img/thumbs-up-black.6ec08866.svg";